import { Ajax2 } from '@shared/Ajax';

const taskStatusLabel = {
    inreview: kuura.getMessage('workflows.tasks.status.in_review'),
    completed: kuura.getMessage('workflows.tasks.status.completed'),
    created: kuura.getMessage('workflows.tasks.status.created'),
    deleted: kuura.getMessage('workflows.tasks.status.deleted'),
    approved: kuura.getMessage('workflows.tasks.status.approved'),
    rejected: kuura.getMessage('workflows.tasks.status.rejected'),
};

function actorsUnflatten(raw: IWorkflowStep | IWorkflowTask) {
    if (raw.reviewerUsers) {
        raw.reviewerUsers = raw.reviewerUsers.filter(Boolean).map(uuid => ({ uuid })) as any;
    }
    if (raw.reviewerRoles) {
        raw.reviewerRoles = raw.reviewerRoles.filter(Boolean).map(uuid => ({ uuid })) as any;
    }
    if (raw.reviewerGroups) {
        raw.reviewerGroups = raw.reviewerGroups.filter(Boolean).map(uuid => ({ uuid })) as any;
    }
    if (raw.initiatorUsers) {
        raw.initiatorUsers = raw.initiatorUsers.filter(Boolean).map(uuid => ({ uuid })) as any;
    }
    if (raw.initiatorRoles) {
        raw.initiatorRoles = raw.initiatorRoles.filter(Boolean).map(uuid => ({ uuid })) as any;
    }
    if (raw.initiatorGroups) {
        raw.initiatorGroups = raw.initiatorGroups.filter(Boolean).map(uuid => ({ uuid })) as any;
    }

    const task = raw as IWorkflowTask;
    if (task.documents) {
        task.documents = task.documents.filter(Boolean).map(uuid => ({ uuid })) as any;
    }
}

function actorsFlatten(raw: IWorkflowStep | IWorkflowTask) {
    if (raw.initiatorUsers) {
        raw.initiatorUsers = (raw.initiatorUsers || []).map((u: any) => u.uuid);
    }
    if (raw.initiatorRoles) {
        raw.initiatorRoles = (raw.initiatorRoles || []).map((u: any) => u.uuid);
    }
    if (raw.initiatorGroups) {
        raw.initiatorGroups = (raw.initiatorGroups || []).map((u: any) => u.uuid);
    }
    if (raw.reviewerUsers) {
        raw.reviewerUsers = (raw.reviewerUsers || []).map((u: any) => u.uuid);
    }
    if (raw.reviewerRoles) {
        raw.reviewerRoles = (raw.reviewerRoles || []).map((u: any) => u.uuid);
    }
    if (raw.reviewerGroups) {
        raw.reviewerGroups = (raw.reviewerGroups || []).map((u: any) => u.uuid);
    }
    const task = raw as IWorkflowTask;
    if (task.documents) {
        task.documents = task.documents.map((u: any) => u.uuid);
    }
}

function getTaskStatusClass(status: string) {
    if (status === 'inreview' || status === 'created') {
        return 'task-status-cell task-status-cell--warn';
    }
    if (status === 'deleted' || status === 'rejected') {
        return 'task-status-cell task-status-cell--danger';
    }
    if (status === 'completed' || status === 'approved') {
        return 'task-status-cell task-status-cell--success';
    }
}

function getTaskTimeRemaining(task: IWorkflowTask) {
    if (!task.timeRemaining || task.completedDate) return null;
    return `${task.timeRemaining} (${new Date(task.timeAllowedUntilDate).toLocaleDateString()})`;
}

function getAssignedString(task: IWorkflowTask) {
    const anyInitiator = task.initiatorUsers.length + task.initiatorGroups.length + task.initiatorRoles.length;
    const anyReviewer = task.reviewerUsers.length + task.reviewerGroups.length + task.reviewerRoles.length;

    return {
        initiators: anyInitiator ? kuura.getMessage('general.n_users_n_groups_n_roles', task.initiatorUsers.length, task.initiatorGroups.length, task.initiatorRoles.length) : '/',
        reviewers: anyReviewer ? kuura.getMessage('general.n_users_n_groups_n_roles', task.reviewerUsers.length, task.reviewerGroups.length, task.reviewerRoles.length) : '/',
    };
}

function getAssignedTooltip(users: any[], groups: any[], roles: any[]) {
    return `Users:\n
    ${users.map(u => u.firstname + ' ' + u.lastname + ' (' + u.username + ')').join('\n')}`;
}

function fetchTask(taskUuid: string): Promise<IWorkflowTask> {
    return Ajax2({
        url: `${kuura.getContextPath()}/api/1/tasks/${taskUuid}`,
        params: {
            projectUuid: kuura.getProjectUuid(),
        },
    });
}

function fetchTaskHistory(taskUuid: string): Promise<IWorkflowTaskHistoryEntry[]> {
    return Ajax2({
        url: `${kuura.getContextPath()}/api/1/workflow-events/by-task/${taskUuid}`,
        params: {
            projectUuid: kuura.getProjectUuid(),
        },
    });
}

function fetchDocumentHistory(fileUuid: string): Promise<IWorkflowTaskHistoryEntry[]> {
    return Ajax2({
        url: `${kuura.getContextPath()}/api/1/workflow-events/by-document/${fileUuid}`,
        params: {
            projectUuid: kuura.getProjectUuid(),
        },
    });
}

export const WorkflowsService = {
    taskStatusLabel,
    actorsFlatten,
    actorsUnflatten,
    getTaskStatusClass,
    getTaskTimeRemaining,
    getAssignedString,
    getAssignedTooltip,
    fetchDocumentHistory,
    fetchTaskHistory,
    fetchTask,
};
